var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ValidationObserver',{ref:"observer",attrs:{"slim":""},on:{"submit":function($event){$event.preventDefault();}}},[_c('v-form',[_c('discount-info',{attrs:{"target-discount-enabled":_vm.discountEnabled,"target-discount-info":_vm.discountInfo},on:{"update-discount-info":_vm.updateDiscountInfo}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }